module.exports = __webpack_public_path__ + "static/media/raise_ticket_icon.a0e23ecd.svg";